import { EnumDisplayLanguage } from '../../../../../../api/com/MetaPattern/MDA/Designer/Base/EnumDisplayLanguage';
import { LineShape } from '../../../../../../api/com/MetaPattern/MDA/Designer/Shape/LineShape';
import { BaseElement } from '../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { BaseAssociation } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BaseAssociation';
import { EnumMultiplicityMD } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumMultiplicity';
import { RelationshipLink } from './RelationshipLink';

// 关联线，具有源、目标定义
export abstract class AssoLink extends RelationshipLink {
  // 获取关系元数据
  get association(): BaseAssociation {
    return this.element() as BaseAssociation;
  }

  setMD (lineShape: LineShape, model: BaseElement, isFromJSON: boolean, source?: any, target?: any) {
    super.setMD(lineShape, model, isFromJSON, source, target);
    this.addLabels();
  }

  /**
   * 添加线的文本，只有源和目标都是元素的时候才添加
   */
  protected addLabels() {
    while (this.labels().length > 0) {
      this.removeLabel(0);
    }
    let sourceDistance = -20;
    let targetDistance = 20;
    let sourceLabel = this.association.sourceName;
    let targetLabel = this.association.targetName;
    if (this.displayLanguage === EnumDisplayLanguage.Chinese) {
      sourceDistance = sourceDistance - this.association.sourceDisplayName.length * 8 / 2; // 每个中文8像素，居中对齐只计算一半
      sourceLabel = this.association.sourceDisplayName;
      targetDistance = targetDistance + this.association.targetDisplayName.length * 8 / 2;
      targetLabel = this.association.targetDisplayName;
    } else {
      sourceDistance = sourceDistance - this.association.sourceName.length * 4 / 2; // 每个英文4像素，居中对齐只计算一半
      sourceLabel = this.association.sourceName;
      targetDistance = targetDistance + this.association.targetName.length * 4 / 2;
      targetLabel = this.association.targetName;
    }
    // source
    this.appendLabel({
      attrs: {
        text: { text: EnumMultiplicityMD.getItem(this.association.sourceMultiplicity).displayName, fill: 'white', fontSize: 10 },
        rect: { fillOpacity: 0.1 }
      },
      position: { distance: -20, offset: 10, args: { keepGradient: true, ensureLegibility: true } }
    });
    this.appendLabel({
      attrs: {
        text: { text: sourceLabel, fill: 'white', fontSize: 10 },
        rect: { fillOpacity: 0.1 }
      },
      position: { distance: sourceDistance, offset: -10, args: { keepGradient: true, ensureLegibility: true } }
    });
    // target
    this.appendLabel({
      attrs: {
        text: { text: EnumMultiplicityMD.getItem(this.association.targetMultiplicity).displayName, fill: 'white', fontSize: 10 },
        rect: { fillOpacity: 0.1 }
      },
      position: { distance: 20, offset: 10, args: { keepGradient: true, ensureLegibility: true } }
    });
    this.appendLabel({
      attrs: {
        text: { text: targetLabel, fill: 'white', fontSize: 10 },
        rect: { fillOpacity: 0.1 }
      },
      position: { distance: targetDistance, offset: -10, args: { keepGradient: true, ensureLegibility: true } }
    });
  }

  setDisplayLanguage(displayLanguage: EnumDisplayLanguage): void {
    super.setDisplayLanguage(displayLanguage);
    this.addLabels();
  }

  refresh(): void {
    this.addLabels();
  }
}
